export const NOTIFICATION_TYPES = {
  error: 'error',
  success: 'success',
  info: 'info',
  warning: 'warning',
};
